import { useEffect, useMemo, useState, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { VERSION as ENSO_VERSION, type AboutInfo } from '@ohpen/enso-ui';
import { useConfig, type IApp } from '@ohpen/react-utils';

import { ConfigApp } from '@config';
import { aboutGet } from '@config/api';

const APPLICATION_ID = 'pmp';

/**
 * What the standalone portal hands the configuration module. The sections whose data has no
 * backend yet render their own "coming soon" state, so only the identity of the application and
 * the About entry are supplied here.
 */
export const PortalHost = (): ReactElement => {
  const { t } = useTranslation();
  const config = useConfig<IApp>();
  const [apiVersion, setApiVersion] = useState<string>();

  useEffect(() => {
    let cancelled = false;
    aboutGet()
      .then(({ data }) => {
        if (!cancelled) setApiVersion(data?.version);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);

  const aboutInfo: AboutInfo = useMemo(
    () => ({
      items: [
        { label: t('portal.about.portalVersion'), value: config.VERSION || '-' },
        { label: t('portal.about.apiVersion'), value: apiVersion || '-' },
        { label: t('portal.about.ensoUiVersion'), value: ENSO_VERSION },
        { label: t('portal.about.stage'), value: config.STAGE || '-' },
        { label: t('portal.about.client'), value: config.CLIENT || '-' },
      ],
    }),
    [apiVersion, config, t],
  );

  return <ConfigApp application={APPLICATION_ID} applicationName={t('portal.applicationName')} aboutInfo={aboutInfo} />;
};
